export const CITY_METRICS_HEADERS = [
  {
    key: 'cityId',
    label: 'City name',
    type: 'dropdownCity',
  },
  {
    key: 'totalFlyers',
    label: 'Total flyers',
    type: 'number',
  },
  {
    key: 'totalMissions',
    label: 'Total missions',
    type: 'number',
  },
  {
    key: 'distributionCost',
    label: 'Distribution cost',
    type: 'currencySign',
  },
  {
    key: 'travelCost',
    label: 'Travel cost',
    type: 'currencySign',
  },
  {
    key: 'permitCost',
    label: 'Permit cost',
    type: 'currencySign',
  },
  {
    key: 'printingCost',
    label: 'Printing cost',
    type: 'currencySign',
  },
  {
    key: 'bonusBudget',
    label: 'Bonus budget',
    type: 'currencySign',
  },
  {
    key: 'postingCost',
    label: 'Posting cost',
    type: 'currencySign',
  },
  {
    key: 'dataCost',
    label: 'Data cost',
    type: 'currencySign',
  },
  {
    key: 'outfitCost',
    label: 'Outfit cost',
    type: 'currencySign',
  },
  {
    key: 'freightCost',
    label: 'Freight cost',
    type: 'currencySign',
  },
  {
    key: 'totalCost',
    label: 'Total cost',
    type: 'currencySignTotal',
  },
  {
    key: 'delete',
    label: '',
    type: 'delete',
  },
]
